import styled from 'styled-components';
import { strictSpace } from '../../utils';
export var Drawer = styled.div.withConfig({
  displayName: "styles__Drawer",
  componentId: "sc-1uv28yf-0"
})(["background-color:", ";padding-top:2.5rem;padding-left:", ";padding-right:", ";padding-bottom:4rem;z-index:1000;position:fixed;bottom:-", ";left:0;right:0;border-top-left-radius:", ";border-top-right-radius:", ";will-change:transform;touch-action:none;user-select:none;white-space:pre-line;overflow:auto;", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.bgElevated;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.s;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.s;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.xl;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.radius8;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderRadius.radius8;
}, strictSpace);
export var Backdrop = styled.div.withConfig({
  displayName: "styles__Backdrop",
  componentId: "sc-1uv28yf-1"
})(["position:fixed;background-color:", ";top:0;right:0;bottom:0;left:0;z-index:9;touch-action:none;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.overlay;
});
export var CloseButton = styled.button.withConfig({
  displayName: "styles__CloseButton",
  componentId: "sc-1uv28yf-2"
})(["background:transparent;border:none;position:absolute;top:", ";right:", ";font-size:1.5rem;color:", ";cursor:pointer;outline:none;line-height:1;height:2rem;padding:", ";&:focus{background-color:hsla(0,0%,0%,0.2);border-radius:", ";}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.s;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.s;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.textPrimary;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.min;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.borderRadius.radius8;
});